module.exports = __webpack_public_path__ + "img/tab-history.55dbec43.png";